"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productToUpdateMapper = void 0;
exports.productToUpdateMapper = function (item) {
    return {
        name: item.name,
        description: item.description,
        sku: item.sku,
        priceData: {
            price: item.price,
        },
        pricePerUnitData: item.pricePerUnitData,
        discount: item.discount,
        productOptions: item.productOptions
            ? Object.entries(item.productOptions).map(function (_a) {
                var key = _a[0], value = _a[1];
                return {
                    name: key,
                    choices: value.choices.map(function (choice) { return ({
                        value: choice.value,
                        description: choice.description,
                    }); }),
                };
            })
            : [],
        manageVariants: item.manageVariants,
        productType: item.productType,
        weight: item.weight,
        visible: item.visible,
        seoData: item.seoData,
        ribbon: item.ribbon,
        brand: item.brand,
    };
};
//# sourceMappingURL=productToUpdate.mapper.js.map